var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31289 9.51289C5.70342 9.90342 6.33658 9.90342 6.72711 9.51289L10.465 5.775C10.7356 5.50438 10.7356 5.06562 10.465 4.795C10.1944 4.52438 9.75562 4.52438 9.485 4.795L6.72711 7.55289C6.33658 7.94342 5.70342 7.94342 5.31289 7.55289L4.515 6.755C4.24438 6.48438 3.80562 6.48438 3.535 6.755C3.26438 7.02562 3.26438 7.46438 3.535 7.735L5.31289 9.51289ZM7 14C6.03167 14 5.12167 13.8162 4.27 13.4487C3.41833 13.0812 2.6775 12.5825 2.0475 11.9525C1.4175 11.3225 0.91875 10.5817 0.55125 9.73C0.18375 8.87833 0 7.96833 0 7C0 6.03167 0.18375 5.12167 0.55125 4.27C0.91875 3.41833 1.4175 2.6775 2.0475 2.0475C2.6775 1.4175 3.41833 0.91875 4.27 0.55125C5.12167 0.18375 6.03167 0 7 0C7.96833 0 8.87833 0.18375 9.73 0.55125C10.5817 0.91875 11.3225 1.4175 11.9525 2.0475C12.5825 2.6775 13.0812 3.41833 13.4487 4.27C13.8162 5.12167 14 6.03167 14 7C14 7.96833 13.8162 8.87833 13.4487 9.73C13.0812 10.5817 12.5825 11.3225 11.9525 11.9525C11.3225 12.5825 10.5817 13.0812 9.73 13.4487C8.87833 13.8162 7.96833 14 7 14Z",
    fill: "#222632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.b3e77937f234a131d75e0c177c81211b.svg";
export { ForwardRef as ReactComponent };